import { Flex } from "@chakra-ui/react";
import { ImmutableArray } from "@hookstate/core";
import { SortDurationMenu } from "./SortDurationMenu";
import { SortOrderMenu } from "./SortOrderMenu";

export interface SortMenusProps {
  invalidate?: () => void;
  sortOrder?: string;
  sortDuration?: string;
  onSortOrderChange: (value: string) => void;
  onSortDurationChange: (value: string) => void;
  sortOrders?: ImmutableArray<{
    id: string;
    name: string;
  }>;
}
export function SortMenus({
  invalidate,
  sortOrder,
  sortDuration,
  onSortOrderChange,
  onSortDurationChange,
  sortOrders,
}: SortMenusProps) {
  return (
    <Flex position="relative" gap={2}>
      <SortOrderMenu
        invalidate={invalidate}
        sortOrder={sortOrder}
        onSortOrderChange={onSortOrderChange}
        sortOrders={sortOrders}
      />
      <SortDurationMenu
        invalidate={invalidate}
        sortOrder={sortOrder}
        sortDuration={sortDuration}
        onSortDurationChange={onSortDurationChange}
      />
    </Flex>
  );
}
